import React, {useState} from 'react'
import {Link} from 'react-router-dom'

export default function Checkout() {
    const [counter, setCounter] = useState(1)
    const [stok, setStok] = useState(231)
    const [price, setPrice] = useState(120000)

    // format number
    function toMoney(x) {
        return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
    }

        // penambahan 

        let plusItem = () => {
            setCounter(counter + 1) 
            setStok(stok - 1)
            setPrice(price + 120000)
        }

        let minusItem = () => {
            if(counter <= 1) {
                return setCounter(1)
            }
            setCounter(counter - 1)
            setStok(stok + 1)
            setPrice(price - 120000)
        }
       
    return (
        <div className="checkout">
           <h3>Detail Pembelian</h3>
           <div className="jumlah">
               <p className={`${counter > 1 ? "active-minus" : ""} minus`} onClick={minusItem}>-</p>
                            <p>{counter}</p>
                            <p className="plus" onClick={plusItem}>+</p>
                        </div>
                        <p>Sisa Stok Barang {stok}</p>
                        <div className="total">
                            <p>Subtotal</p>
                            <h3>Rp. {toMoney(price)}</h3>
                        </div>
                        <div className="tombol">
                            <button type="button">
                                <Link to="#">Bagikan</Link>
                            </button>
                            <button type="button">
                                <Link to="#">Beli</Link>
                            </button>
                        </div>
                        <div className="input-keranjang">
                            <button type="button" id="id_keranjang">Masukkan Keranjang</button>
                            <img src="asset/product/toko.svg" alt="toko" />
                        </div>
                    </div>
    )
}
